import { Injectable } from '@angular/core';
import { Toast } from '@inera/common';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new BehaviorSubject<Toast[]>([]);
  private toasts: Toast[] = [];

  removeToast(toast: Toast): void {
    this.toasts = this.toasts.filter(t => t.id !== toast.id);
    this.toastSubject.next(this.toasts);
  }

  killTimer(toast: Toast): void {
    if (toast.timeout) {
      clearTimeout(toast.timeout);
      toast.timeout = null;
    }
  }

  resumeTimer(toast: Toast): void {
    this.killTimer(toast); // Ensure the previous timer is cleared
    toast.timeout = setTimeout(() => {
      this.removeToast(toast);
    }, toast.timeout || 4000);
  }

  addToast(toast: Toast): void {
    toast.timeout = setTimeout(() => {
      this.removeToast(toast);
    }, toast.timeout || 4000);

    this.toasts.push(toast);
    this.toastSubject.next(this.toasts);
  }

  public connect(): Observable<Toast[]> {
    return this.toastSubject.asObservable();
  }
}
